import { NgModule } from '@angular/core';
import { SafeHtmlPipe } from './Pipes/SafeHtmlPipe';
import { SafeHtmlPdf} from './Pipes/SafeHtmlPdf';

@NgModule({
    declarations: [SafeHtmlPipe,SafeHtmlPdf],
    exports: [SafeHtmlPipe,SafeHtmlPdf]
})
export class DefaultPipeModule { }